module.exports = __webpack_public_path__ + "img/authentication.2387faf5.svg";